module.exports = {
    language: 'nl',
    skin_url: '/css/tinymce/skins/ui/CUSTOM',
    menubar: false,
    toolbar_location: 'top',
    statusbar: false,
    content_css: '/css/tinymce/skins/content/CUSTOM/content.css',
    relative_urls: false,
    setup: (editor) => { editor.on('change', function () { editor.save() }) },
    plugins : 'lists charmap table hr image link searchreplace paste directionality noneditable visualchars code anchor',
    toolbar : 'bold italic underline strikethrough forecolor | alignleft aligncenter alignright alignjustify | undo redo | cut copy paste pastetext pasteword formatselect visualchars code | bullist numlist | outdent indent blockquote | link unlink anchor image | charmap | subscript superscript | hr removeformat',
    contextmenu: 'cut copy paste pastetext | emoticons charmap link | imagetools',
    toolbar_mode: 'sliding',
    height: 350,
}